var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo",attrs:{"to":{name: 'index'}}},[_c('v-icon',[_vm._v("mdi-bullseye-arrow")]),_c('span',{staticClass:"logo__text"},[_vm._v("uday.club")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }